var initializeHeroBlock = function(block){
	
	var slick = jQuery('.slick', block);
	var slideCount = jQuery('.slide', slick).length;
	
	if(slideCount > 1) {
	
		jQuery('.slick', block).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			rows: 1,
			slidesPerRow: 1,
			dots: true,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 5000,
			fade: false,
			easing: "linear",
			pauseOnHover: false,
			infinite: true,
			draggable: false,
			swipe: false,
			adaptiveHeight: false
		});
		
	}

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-hero').each(function(){
		initializeHeroBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=hero', initializeHeroBlock);
